import { Link } from 'react-router-dom';
import { SivMark } from './SivMark';

/**
 * The lockup: hexagon mark plus wordmark, with "VALIDATOR" carrying the
 * emerald V from the brand sheet. Compact drops the tagline for tight
 * placements such as the mobile bar.
 */
export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/" className="group inline-flex shrink-0 items-center gap-2.5 no-underline">
      <SivMark size={compact ? 28 : 34} className="shrink-0" />

      <span className="flex flex-col leading-none whitespace-nowrap">
        <span className="text-text text-[0.9rem] font-extrabold tracking-tight">STARTUP IDEA</span>
        <span className="text-[1.05rem] font-extrabold tracking-tight">
          <span className="text-emerald">V</span>
          <span className="text-blue">ALIDATOR</span>
        </span>
        {!compact && (
          <span className="font-mono text-faint mt-1.5 text-[0.5rem] font-bold tracking-[0.14em] uppercase">
            From idea to evidence
          </span>
        )}
      </span>

      <span className="sr-only">Startup Idea Validator by GodEngine — home</span>
    </Link>
  );
}
